'use strict';
//import $ from 'jquery';
//window.$ = window.jQuery = $;

window._ = require('lodash');
window.$ = window.jQuery = require('jquery');
// Variations that I tried - one at a time
require('materialize-css');
require('jquery-lazy');
require('slick-carousel');
require('sweetalert');
require('./contact');
require('./newsletter');
require('./work');
var contLogin,campo,emailRegex;

$(function($) {
    $("img.lazy").Lazy({
        chainable: false,
        threshold: 500,
        visibleOnly: false,
    });
});

$(document).ready(function(){
    function cargar(){
        setTimeout(function () {
            $('#loading').css('display','none');
            $('#content').css('visibility','initial');
            $('body').css('overflow-x','visible');
            $('body').css('overflow-y','visible');
        },0);
    }
    window.load = cargar();
    $('.sidenav').sidenav({
        edge: 'left'
    });
    $('#side-contact').sidenav({
        edge: 'right'
    });
    $('#side-pqrs').sidenav({
        edge: 'right'
    });
    $('#side-employee').sidenav({
        edge: 'right'
    });
    $(".dropdown-trigger").dropdown({
        hover: false,
        alignment: 'center'
    });
    $('.modal').modal();
});

$('.close-menu').click(function () {
    $('.sidenav').sidenav('close');
});
$('#employee-dropdown .clickModalOpen').click(function () {
    $.ajax({
        url: https + "getCategories",
        method: "POST",
        data: {category_id:this.id,action:'getCategories'},
        success: function (data) {
            $('#modalEmployee #modalView').html('');
            $('#modalEmployee #modalView').html(data);
            $('#modalEmployee').modal('open');
        }
    });
});
var validateMenuEmployeeMobile = 1;
$('#mobile_menu .employee').click(function () {
    if(validateMenuEmployeeMobile == 1){
        $('#mobile_menu .container-employee').css('display','block')
        validateMenuEmployeeMobile = 2;
    }else{
        $('#mobile_menu .container-employee').css('display','none')
        validateMenuEmployeeMobile = 1;
    }
});

$('#employee-dropdown .clickBlog').click(function () {
    $('html, body').animate({
        scrollTop: $('#blog').offset().top - 100
    }, 1000);
});

$('.clickAbout').click(function () {
    $('html, body').animate({
        scrollTop: $('#about').offset().top - 100
    }, 1000);
    $('.header .nav-wrapper a').removeClass('active');
    $('.header .nav-wrapper .clickAbout').addClass('active');
});

$('.clickGps').click(function () {
    $('html, body').animate({
        scrollTop: $('#footer').offset().top - 100
    }, 1000);
});


$('.clickServices').click(function () {
    $('html, body').animate({
        scrollTop: $('#services').offset().top - 100
    }, 1000);
    $('.header .nav-wrapper a').removeClass('active');
    $('.header .nav-wrapper .clickServices').addClass('active');
});

$('.clickEmployees').click(function () {
    $('.header .nav-wrapper a').removeClass('active');
    $('.header .nav-wrapper .clickEmployees').addClass('active');
});


$('.clickContact').click(function () {
    $('#side-contact').sidenav('open');
    $('.header .nav-wrapper a').removeClass('active');
    $('.header .nav-wrapper .clickContact').addClass('active');
});
$('.clickpqrs').click(function () {
    $('#side-pqrs').sidenav('open');
    $('.header .nav-wrapper a').removeClass('active');
    $('.header .nav-wrapper ').addClass('active');
});

$('.openEmployees').click(function () {
    $('#side-employee').sidenav('open');
    $('.header .nav-wrapper a').removeClass('active');
    $('.header .nav-wrapper .openEmployees').addClass('active');
});



$('.close-contact').click(function () {
    $('#side-contact').sidenav('close');
});
$('.close-pqrs').click(function () {
    $('#side-pqrs').sidenav('close');
});

$(document).bind('keydown',function(e){
    if ( e.which == 27 ) {
    $('#side-pqrs').sidenav('close');
    $('#side-contact').sidenav('close');
    $('#side-employee').sidenav('close');

    };
});

$('.close-employee').click(function () {
    $('#side-employee').sidenav('close');
});

$(window).scroll(function() {
    if ($(window).width() > 991) {
        if ($(document).scrollTop() > 96) {
            $('.header').css('background', '#ffffff', '!important');
            $('.header').addClass('header-shadow');
            $('.header .brand-logo .desktop').attr('src', https + 'img/header/logo_down_2.svg');
            $('.header').css('height', '85px', '!important');
            $('.header').css('line-height', '85px', '!important');
            $('.header .brand-logo .desktop').css('margin-top', '-7%', '!important');
            $('.header .line').css('visibility', 'hidden', '!important');
            $('.header a').css('color', '#003447', '!important');
            $('.header .buton').css('top', '25px', '!important');
            $('.header .pqrs').css('top', '25px', '!important');
            $('.header .work_us').css('top', '25px', '!important');
            $('.header .buton i').css('color', '#003447', '!important');
        } else {
            if ($(document).scrollTop() >= 0 && $(document).scrollTop() <= 85) {
                $('.header').css('background', 'transparent', '!important');
                $('.header').removeClass('header-shadow');
                $('.header .brand-logo .desktop').attr('src', https + 'img/header/logo_2.svg');
                $('.header').css('height', '100px', '!important');
                $('.header').css('line-height', '100px', '!important');
                $('.header .brand-logo .desktop').css('margin-top', '-2%', '!important');
                $('.header .line').css('visibility', 'inherit', '!important');
                $('.header a').css('color', '#ffffff', '!important');
                $('.header .buton i').css('color', '#ffffff', '!important');
                $('.header .buton').css('top', '33px', '!important');
                $('.header .pqrs').css('top', '30px', '!important');
                $('.header .work_us').css('top', '30px', '!important');


            }
        }
    }
});

$(document).ready(function () {
    $('#sliderHome').slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 10000,
    });
    $('#sliderHomeMob').slick({
        arrows: false,
        dots: true,
        autoplay: true,
        autoplaySpeed: 10000,
    });
    
    //started sliderbanner
    /*
    $('#sliderBanner').slick({
        dots: true,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        cssEase: 'easeOutElastic',
        fade: true,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        dotsClass: 'custom-dots',
        customPaging: function (slider, i) {
            //FYI just have a look at the object to find aviable information
            //press f12 to access the console
            //you could also debug or look in the source
            console.log(slider);
            var slideNumber = (i + 1),
                totalSlides = slider.slideCount;
            return '<a class="dot" role="button" title="' + slideNumber + ' of ' + totalSlides + '"><span class="string">0' + slideNumber+'</span></a>';
        },
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    dotsClass: 'slick-dots',
                    customPaging: function (slider, i) {
                        //FYI just have a look at the object to find aviable information
                        //press f12 to access the console
                        //you could also debug or look in the source
                        console.log(slider);
                        var slideNumber = (i + 1),
                            totalSlides = slider.slideCount;
                        return '<a class="dot" role="button" title="' + slideNumber + ' of ' + totalSlides + '"><span class="string">·</span></a>';
                    }
                }
            }
        ]
    });

    $('#sliderBanner').on('beforeChange', function(event, slick, currentSlide, nextSlide){
        //$(".sectionBanner img").css('transition','transform 0s');
        $(".sectionBanner img").css('transform','scale(1.1)');
        $(".sectionBanner .element").removeClass('animated fadeInUp');
        $(".sectionBanner .element").addClass('animated fadeOutUp');
    });
    $('#sliderBanner').on('afterChange', function(event, slick, currentSlide, nextSlide){
        setTimeout(function () {
            //$(".sectionBanner img").css('transition','transform 4s');
            //$(".sectionBanner img").css('transform','scale(1)');
            $(".sectionBanner .element").removeClass('animated fadeOutUp');
            $(".sectionBanner .element").addClass('animated fadeInUp');
        },100);
    });
    */
    //end sliderbanner


    $('#sliderBrands').slick({
        dots: true,
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                },
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4,
                },
            },
            {
                breakpoint: 850,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                },
            }
        ]
    });

    $('#sliderServices').slick({
        centerMode: true,
        dots: false,
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        swipe: true,
        pauseOnHover: false,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        prevArrow: $('.sectionServices .butons .prev'),
        nextArrow: $('.sectionServices .butons .next'),
        lazyLoad: 'ondemand',
        //mobileFirst: true,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    adaptiveHeight: false,
                }
            },
        ]
    });

    $('#sliderBlog').slick({
        dots: false,
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        adaptiveHeight: true,
        arrows: true,
        autoplay: false,
        autoplaySpeed: 3000,
        prevArrow: $('.prev-slider-sliderBlog'),
        nextArrow: $('.next-slider-sliderBlog'),
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 750,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    setTimeout(function () {
        var token_instagram = instagram_token;
        var URL_API_INSTAGRAM = "https://graph.instagram.com/me?fields=username,media&access_token="+token_instagram;
        $.getJSON(URL_API_INSTAGRAM, function (data) {
            var i = 1;
            var url_instagram = '';
            $('.instagramImages').html("");
            $.each(data.media.data, function (item, value) {
                if (i <= 4) {
                    var MediaInstagram = "https://graph.instagram.com/"+value.id+"?fields=caption,media_url,media_type,id,permalink,thumbnail_url&access_token="+token_instagram;
                    $.getJSON(MediaInstagram, function (data_media) {
                        if(data_media.media_type === 'VIDEO'){
                          url_instagram = data_media.thumbnail_url;
                        }else{
                          url_instagram = data_media.media_url;
                        }
                        $('.instagramImages').append('' +
                          '                                <div class="inst">\n' +
                          '                                    <a target="_blank" href="'+data_media.permalink+'">\n' +
                          '                                        <div class="containerInstagram" >\n' +
                          '                                            <div class="imgInsta" >\n' +
                          '                                                <img src="'+url_instagram+'" alt="">\n' +
                          '                                            </div>\n' +
                          '                                        </div>\n' +
                          '                                    </a>\n' +
                          '                               </div>');
                    });            
                }
                i++;
            });
        });
     },10);
});

var input_eye_pass=0;
$('.input_eye_pass').click(function () {
    if(input_eye_pass == 0){
        $('#pass').attr('type', 'text');
        input_eye_pass = 1;
    }else{
        $('#pass').attr('type', 'password');
        input_eye_pass = 0;
    }
});

$(document).ready(function() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
});

$('.clickCloseSesion').click(function () {
   location.href = https + 'logout';
});

$('#modalEmployee .type_tree .element h1').click(function () {
    $('#modalEmployee .type_tree .element h1').removeClass('active');
    $(this).addClass('active');
    $('#modalEmployee .type_tree .element .div').css('display','none');
    $('#modalEmployee .type_tree .element .div_'+this.id).css('display','none');
});

